import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {Image} from '@app/components/Image';
import {LandingButtonLink} from '@app/components/landing-btn-link';
import {useIsVerboseLocale} from '@app/hooks/use-verbose-locale';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';

export const OfflineSection: FunctionComponent = () => {
	const {t} = useTranslation();
	const isVerboseLocale = useIsVerboseLocale();
	const fontSize = isVerboseLocale
		? {base: '3xl', sm: '5xl', xl: '6xl'}
		: undefined;

	return (
		<LandingIllustrationSection
			imagePosition="right"
			description={
				<>
					<LandingHeading as="h2" fontSize={fontSize}>
						{t('featureslandingpage_title_nointernetnoproblem_standalone-web', {
							ns: 'features',
						})}
					</LandingHeading>
					<LandingParagraph>
						{t('featureslandingpage_text_nointernetnoproblem_standalone-web', {
							ns: 'features',
						})}
					</LandingParagraph>
				</>
			}
			image={
				<Image
					h={{base: '310px', md: '100%'}}
					quality={90}
					sizes={{base: '100vw', md: '50vw'}}
					alt={t('metatag_text_offlinemusic_standalone-web', {ns: 'common'})}
					src="cddc65ac0ba68d7d00f083e70b917dc0.jpg"
					aspectRatio="2048/1230"
					width={{base: '100%', md: '70%'}}
				/>
			}
			cta={
				<LandingButtonLink
					tracking={{eventaction: 'discover', eventlabel: 'offline'}}
					href="/features/offline"
				>
					{t('generic_action_discoveroffline_standalone-web', {ns: 'common'})}
				</LandingButtonLink>
			}
		/>
	);
};
